import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { constantValues, endPoints } from '../../constants'
import { sendOTP } from '../../redux/slices/user'
import { RootState } from '../../redux/store'
import { APIMethods, ReqBodyWithHeaders } from '../../types/state'
import Timer from '../Timer'
import { ChangeWrapper, OTPText } from './styles'

const OTPTimer = () => {
	const [showResend, SetShowResend] = useState(false)
	const userData = useSelector((state: RootState) => state.user)
	const metaData = useSelector((state: RootState) => state.meta)
	const translations = useSelector(
		(state: RootState) => state.translations.data
	)
	const dispatch = useDispatch()

	const toggleTimer = (status: boolean) => {
		SetShowResend(status)
	}

	const onResendClick = () => {
		const reqObj: ReqBodyWithHeaders = {
			method: APIMethods.POST,
			url: endPoints.resendOTP,
			telephone: userData.phone,
			phoneCode: '+91',
			client: metaData.deviceType,
			sessionId: userData.sessionId,
		}
		dispatch(sendOTP(reqObj))
		SetShowResend(false)
	}

	return (
		<OTPText>
			{!showResend && <span>{translations.OTP_RESEND}</span>}
			{!showResend && (
				<Timer
					seconds={constantValues.otp_timer}
					checkTimer={() => toggleTimer(true)}
				/>
			)}
			{showResend && (
				<ChangeWrapper onClick={onResendClick}>
					{translations.RESEND}
				</ChangeWrapper>
			)}
		</OTPText>
	)
}
export default OTPTimer
